//BD: PerfilAcesso
export const enum EGuidPerfilAcesso {
  'GerenteGPC' = 'f1cc67b3-abcb-487f-8b38-b35760e264e5', // 4 - Gerente Adm. Contratos
  'AdministradorGPC' = '1642cf10-9b32-489f-98eb-5be22b2bbaa4',// 5 - Administrador AC/ACS - 
  'AdministradorContratoMRN' = '7ed9e512-c30e-45f6-b7c8-17d77958a142',// 6 - Administrador de Contrato MRN
  'GerenciaSenior' = '041d113b-6109-4e3b-825a-7d691da2cadc',// 11 - Gerência Sênior
  'FornecedorSAS' = '7396838a-01ae-4444-b228-2343397c55da', // 33 - Fornecedor SAS
  'GestorTecnico' = '93001b92-4226-466e-9431-4b44b72ebda7', // 31 - Gestor Técnico_SAS
  'PreContratacao' = '15b4e007-b1fe-4d52-972c-6d0558b5551c', // - 23 - Pré-Contratação
  'GerenteDeCompras' = '2aa773c0-17a7-4caa-8bf3-c905dc6d9bfc',// 25 - Gerente de Compras

  'Demandante' = '0e72d77f-9700-4df0-81c8-0ff09d233b8a', // 29 - Demandante
  'Requisitante' = '09e38449-e91c-4dde-b3c4-0b9637525aa8', // 26 - Requisitante
  'RequisitanteCapex' = '54f89f28-058e-4206-ba16-6debec7d48a3', // 28 - Requisitante CAPEX

  'ResponsavelCES' = 'a8eadba2-88c6-42c0-a695-92d307092b8a', // 1044
  'GerenteDeAquisicao' = '2cf92633-bbab-426a-a734-f60dc9241c0c', // 1045

  'GerenteGeralSas' = 'f18db58f-f619-4f50-9e1e-20afc58cc761', // 1046
  'GerenteDepartamentoSas' = '31947423-7a7a-4b24-af08-90c5c6f7cbce', // 1047
  'DiretorEspecifico' = 'a7378492-ca10-4571-ab49-a045deb1b734', // 1048
  'DiretorComercial' = 'ead72be8-45f7-43e7-90b2-53c9b9585d63', // 1049
  'DiretorPresidente' = 'dff2f9c3-bd09-475b-8c76-747ee3c2f2e2', // 1050

  'AprovadorJustificativaControleQualidade' = 'e193150f-c387-4b9b-bb32-9add8607b90e', //1051
}
